import script from "./FilterDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./FilterDropdown.vue?vue&type=style&index=0&id=c9871526&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9871526"]])

export default __exports__